module.exports = __webpack_public_path__ + "static/img/_logo.10a1a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_logo.png
// module id = 207
// module chunks = 1